import { useQuery } from '@tanstack/react-query';
import { queryKeys, instancesService } from '@v2/services';
import type { Instance } from '@v2/types';

interface UseInstancesResult {
  instances: Instance[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useInstances = (): UseInstancesResult => {
  const query = useQuery({
    queryKey: queryKeys.instances.lists(),
    queryFn: instancesService.getInstances,
  });

  return {
    instances: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: async () => {
      await query.refetch();
    },
  };
};

export default useInstances;
